var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@mui/system';
import { useDinPlayerContext } from 'hx-din-test-2';
import { AnimatedCircles, StartButton } from 'hx-ui';
import { useManualPreloadImages } from 'hx-util';
import { useNavigate } from 'react-router-dom';
import { pageImages } from '@/pages/images';
import { palette } from '@/theme/palette';
import { sendScrollIntoView } from '@/helpers/send-scroll-into-view.helper';
import { useTrackTestStart } from '@/hooks/use-track-test-start.hook';
var imagesToPreload = {
    desktop: __spreadArray([], Object.values(pageImages), true),
};
export function WelcomePageLayoutContent() {
    var loadImages = useManualPreloadImages(imagesToPreload).loadImages;
    var theme = useTheme();
    var navigate = useNavigate();
    var _a = useDinPlayerContext(), initialize = _a.initialize, progress = _a.state.progress;
    var trackTestStart = useTrackTestStart().trackTestStart;
    function handleStartClick() {
        loadImages();
        trackTestStart();
        initialize().then(function () { return navigate('/before-you-start'); });
        sendScrollIntoView();
    }
    return (_jsx("main", __assign({ className: "items-center py-20" }, { children: _jsx(StartButton, { onClick: handleStartClick, progress: progress, color: theme.palette.common.black, GraphicElement: AnimatedCircles, graphicElementProps: {
                colorTransform: function (index) {
                    var colors = [
                        palette.common.purple,
                        palette.primary.main,
                        palette.common.salmon,
                    ];
                    return colors[index];
                },
                opacityTransform: function (index) {
                    return 0.7 - 0.2 * index;
                },
            }, buttonStyles: {
                color: theme.palette.common.white,
                minWidth: '7.25rem',
                minHeight: '7.25rem',
                textTransform: 'uppercase',
            } }) })));
}
